import { NextApiResponseBody } from 'types/bolt-api/request'
import { ProducerRequestRequestBody } from '@boltenergy-be/shared'

export const postProducerRequest = async (body: ProducerRequestRequestBody): Promise<NextApiResponseBody> => {
  try {
    const res = await fetch(`/api/producers/request`, {
      method: 'POST',
      body: JSON.stringify(body)
    })

    return (await res.json()) as NextApiResponseBody
  } catch (error) {
    return { success: false }
  }
}
